import { render, staticRenderFns } from "./newForm.vue?vue&type=template&id=4895e820&"
import script from "./newForm.js?vue&type=script&lang=js&"
export * from "./newForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports